var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"icon-sbp",attrs:{"src":"/s-images/icons/payment-systems/sbp.svg","alt":"SBP"}})}
var staticRenderFns = []

export { render, staticRenderFns }